module.exports = __webpack_public_path__ + "img/tuto_internet_way_02_01.53c4310a.png";